import { axios } from '@Root/API'

export const remove = (studyProgrammeId, curriculumAccreditationId) => {
	return axios.delete(`program/${studyProgrammeId}/curriculum-accreditation/${curriculumAccreditationId}`)
}
